module.exports = __webpack_public_path__ + "static/media/lots1.740fbb9f.jpg";